import { useNavigate } from "react-router-dom";
import { Button } from "ui/button";
import { deleteNVRIPSpeaker } from "lib/actions";
import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "context/AuthContext";
import { showToast } from "ui/components/common";
import Modal from "react-modal";
import { ConfirmModalStyles } from "lib/constants";
import { SideviewContext } from "context/SideviewContext";
import { useSWRConfig } from "swr";
import TemplateSelector from "./sideBarComponents/templateSelector";
import TierCard from "./sideBarComponents/tierCard";
import { Select } from "antd";
import { getAudioTemplateList } from "pages/dashboard/audioTemplate/service";
import { saveTemplateToIpSpeaker, updateSpeaker } from "./service";

export default function Form({
  orgId,
  siteId,
  objData,
}: {
  orgId: string;
  siteId: string;
  objData: any;
}) {
  const [removeConfirmModalOpen, setRemoveConfirmModalOpen] = useState(false);
  const navigate = useNavigate();
  const { setOpenPanel, setViewData } = useContext(SideviewContext);
  const { mutate: globalMutate } = useSWRConfig();
  const { user } = useContext(AuthContext);
  const [speakerData, setSpeakerData] = useState({ name: objData.name });

  async function handleRemoveDevice(id) {
    try {
      console.log("Removing camera with id = ", id);
      const response = await deleteNVRIPSpeaker(orgId, id);
      showToast(0, "The IP Speaker has been removed successfully!");
      const params = `?siteId=${siteId}&nvrId=${objData.nvrId}&page.limit=100`;
      globalMutate([`/speaker/speakers${params}`, user.token, orgId]);
      setOpenPanel(false);
    } catch (error) {
      console.error(error);
      navigate(`?modal=true&content=${error}`);
    }
  }

  const [templateId, setTemplateId] = useState(null);
  const [audioTemplateList, setAudioTemplateList] = useState([]);
  async function getTemplates() {
    const res = await getAudioTemplateList();
    if (res.status !== 200) {
      showToast(1, "get template failed");
    }
    setAudioTemplateList(
      res.data.templates.map((item) => ({ label: item.name, value: item.id })),
    );
  }
  useEffect(() => {
    getTemplates();
  }, []);

  const onSave = async () => {
    onSaveTemplate();
    onSaveName();
  };

  const onSaveTemplate = async () => {
    const res = await saveTemplateToIpSpeaker(objData.id, templateId, orgId);
    if (res.status !== 200) {
      showToast(1, "save template failed");
    } else {
      setOpenPanel(false);
      setViewData((state) => {
        const newState = { ...state };
        newState.objData.audioTemplateId = templateId;
        return newState;
      });
      showToast(0, "Save template success");
    }
  };

  const onSaveName = async () => {
    const res = await updateSpeaker(objData.id, speakerData, orgId);
    if (res.status !== 200) {
      showToast(1, "There was a problem saving the name. Please try again.");
    } else {
      setOpenPanel(false);
      setViewData((state) => {
        const newState = { ...state };
        newState.objData.name = speakerData?.name;
        return newState;
      });
      showToast(0, "Save name success");
    }
  };

  useEffect(() => {
    setTemplateId(objData.audioTemplateId);
  }, [objData]);
  return (
    <>
      {/* <div>{JSON.stringify(objData)}</div> */}
      <div className="bg-zinc-50 p-3 mt-3 rounded-lg">
        <table className="table-auto gap-y-3">
          <tbody>
            <tr>
              <td className="pb-3 text-neutral-500">Model</td>
              <td className="pb-3 pl-3">{objData.model}</td>
            </tr>
            <tr>
              <td className="pb-3 text-neutral-500">Vendor</td>
              <td className="pb-3 pl-3">{objData.manufacturer}</td>
            </tr>
            <tr>
              <td className="pb-3 text-neutral-500">MAC Address</td>
              <td className="pb-3 pl-3">{objData.macAddress}</td>
            </tr>
            <tr>
              <td className="pb-3 text-neutral-500 text-nowrap">IP Adress</td>
              <td className="pb-3 pl-3">{objData.ipAddress}</td>
            </tr>
            <tr>
              <td className="text-neutral-500 text-nowrap">Serial Number</td>
              <td className="pl-3">{objData.sn}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="mt-4">
        <div className="mb-2 text-sm">Speaker Name</div>
        <input
          id="name"
          name="name"
          type="text"
          className="block w-full rounded-2xl border border-gray-200 px-3 py-4 text-sm outline-2 placeholder:text-gray-500 focus-visible:outline-none "
          aria-describedby="name-error"
          defaultValue={objData.name}
          onChange={(event) => {
            setSpeakerData({
              name: event.target.value,
            });
          }}
        />
      </div>
      <div style={{ marginTop: "24px" }}>
        <div>Audio Template</div>
        <Select
          value={templateId}
          onChange={(e) => setTemplateId(e)}
          options={audioTemplateList}
          style={{ height: "54px", marginTop: "6px", width: "100%" }}
          placeholder="Select Template"
          allowClear
        />
      </div>
      <div className="flex justify-between mt-4">
        <button
          className="flex items-center rounded-2xl bg-white px-[24px] py-[14px] text-base font-semibold text-blue-500 border border-blue-500 transition-colors hover:text-blue-400 hover:border-blue-400 "
          onClick={() => {
            setOpenPanel(false);
          }}
        >
          Close
        </button>
        <Button
          className="bg-white hover:bg-transparent"
          style={{ marginLeft: "50px" }}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            // setRemovedNvrId(objData.id);
            setRemoveConfirmModalOpen(true);
          }}
        >
          <span className="text-red-500 hover:text-red-400">Delete</span>
        </Button>
        <div className="primaryButton" onClick={onSave}>
          Save
        </div>
      </div>
      <Modal
        isOpen={removeConfirmModalOpen}
        style={ConfirmModalStyles}
        contentLabel="Example Modal"
      >
        <h1 className="text-xl font-bold">
          Do you want to delete the IP Speaker?
        </h1>
        <div className="text-base mt-4">
          This IP Speaker will be permanently deleted from this nvr.
        </div>

        <div className="float-right mt-6">
          <button
            className="rounded-2xl bg-white px-6 py-4 border border-blue-500 hover:border-blue-400 text-sm  transition-colors text-blue-500 hover:text-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 active:bg-blue-600 aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
            onClick={() => {
              setRemoveConfirmModalOpen(false);
            }}
          >
            Cancel
          </button>
          <button
            className="ml-4 rounded-2xl px-6 py-4 bg-red-500 text-sm font-medium text-white transition-colors hover:bg-red-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-500 active:bg-red-600 aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
            onClick={() => {
              setRemoveConfirmModalOpen(false);
              handleRemoveDevice(objData.id);
            }}
          >
            Delete
          </button>
        </div>
      </Modal>
    </>
  );
}
